import { type AxiosInstance } from 'axios';

import { DataFeedEngine } from '../env';

import { CfdProvider, CryptoProvider, type IApiProvider } from './providers';

// ? A lookup table over a closed enum: a third engine needs one new entry here, not a rewritten if/else.
export const providerFactoryByEngine: Record<DataFeedEngine, (client: AxiosInstance) => IApiProvider> = {
  [DataFeedEngine.Cfd]: (client) => new CfdProvider(client),
  [DataFeedEngine.Crypto]: (client) => new CryptoProvider(client),
};
